import { initSplitSdk, getTreatments } from '@splitsoftware/splitio-redux';

export const onSplitReady = (splitNames, attributes, dispatch) => () => {
  dispatch(getTreatments({ splitNames, attributes }));
};

export const initSplit = (splitNames, attributes) => dispatch => {
  const splitConfig = {
    core: {
      authorizationKey: process.env.SPLIT_IO_KEY,
      key: 'INNOV_BO_USER',
    },
  };
  dispatch(
    initSplitSdk({
      config: splitConfig,
      onReady: onSplitReady(splitNames, attributes, dispatch),
    }),
  );
};
